import { Rating } from "@mui/material";
import OImage from "components/reusable/OImage";
import { motion } from "framer-motion";
import { isEmpty } from "lodash";
import { useEffect, useState } from "react";
import { AiOutlineClose } from "react-icons/ai";
import { FaCheck, FaEye } from "react-icons/fa";
import { FaCircleArrowLeft } from "react-icons/fa6";
import { Link, useNavigate, useParams } from "react-router-dom";
import { apiGet } from "utils/apiFetch";
import apiPath from "utils/apiPath";
import { Dialog } from "@headlessui/react";
import { IoCloseOutline } from "react-icons/io5";
import helpers from "utils/helpers";
import { useTranslation } from "react-i18next";
const ServiceCard = ({ title, children }) => (
  <motion.div
    whileHover={{ scale: 1.015 }}
    transition={{ type: "spring", stiffness: 200 }}
    className="bg-white rounded-2xl shadow-md p-4 w-full md:w-auto border border-gray-100 hover:shadow-xl"
  >
    <h2 className="font-semibold text-lg text-gray-700 mb-3">{title}</h2>
    <div className="text-sm text-gray-600 space-y-2">{children}</div>
  </motion.div>
);


export default function ImmediateService() {
  const navigate = useNavigate();
  const { id } = useParams();
  const { t } = useTranslation();
  let [isOpenAddFeedback, setIsAddFeedback] = useState('');
  const [requestDetails, setRequestDetails] = useState();
  const getRequestDetails = async (data) => {
    try {
      if (id) {
        const path =helpers.ternaryCondition(localStorage.getItem('activeTab')!=='cancelledByDriver',`${apiPath.getRequestDetailsList}/${id}`,`${apiPath.getRequestList}/cancelled-by-driver-request-detail/${id}`)
        const result = await apiGet(path);
        console.log("result", result);
        const responseData = result?.data?.results;
        if (!isEmpty(responseData)) {
          setRequestDetails(responseData);
          return
        }
        navigate('/service-monitoring')

      }
    } catch (error) {
      console.error("error in get all sub admin list==>>>>", error.message);
    }
  };

  useEffect(() => {
    getRequestDetails()
  }, [localStorage.getItem('activeTab')])
  return (
    <motion.div
      className="p-5 md:p-10 bg-gray-100 min-h-screen flex flex-col gap-8"
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
    >

      <div className="flex active ml-2 ">
        <div className="flex items-center gap-2">
          <Link aria-current="page" className="flex items-center gap-2" to={-1}>
            <FaCircleArrowLeft size={27} />

          </Link>
          <h1 className="text-2xl font-extrabold text-slate-900 tracking-tight">
            {helpers.capitalizeFirstWord(requestDetails?.status)} Service
          </h1>
        </div>
      </div>


      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2 2xl:grid-cols-3 gap-6">
        <ServiceCard title="Booking Details">
          <div className="flex justify-between items-center">
            <b>Booking ID: </b>
            <span>#{requestDetails?.bookingId}</span>
          </div>

          {helpers.andOperator(requestDetails?.transactionDetails?.length > 0, <div className="flex justify-between items-center">
            <b>Transaction ID: </b>
            <span>{requestDetails?.transactionDetails?.find(item => item?.transactionType === "wallet")?.transactionId || "N/A"}</span>
          </div>)}

          <div className="flex justify-between items-center">
            <b>Service Type:</b>
            <span> {requestDetails?.serviceDetails?.name}</span>
          </div>
          <div className="flex justify-between items-center">
            <b>Booking Type:</b>
            <span>{helpers.capitalizeFirstWord(requestDetails?.bookingType)}</span>
          </div>
          <div className="flex justify-between items-center">
            <b> Created At: </b>
            <span>
              {requestDetails?.createdAt
                ? helpers.getDateAndTime(requestDetails?.createdAt)
                : "N/A"}
            </span>
          </div>
          {helpers.andOperator(requestDetails?.completedAt, <div className="flex justify-between items-center">
            <b>Completion Date: </b>
            <span>
              {
                helpers.getDateAndTime(requestDetails?.completedAt)
              }
            </span>
          </div>)}

          {helpers.andOperator(requestDetails?.cancelledAt, <div className="flex justify-between items-center">
            <b>{t('CANCELLATION_DATE_AND_TIME')}: </b>
            <span>
              {
                helpers.getDateAndTime(requestDetails?.cancelledAt)
              }
            </span>
          </div>)}

          {helpers.andOperator(requestDetails?.cancelledBy, <div className="flex justify-between items-center">
            <b>{t('CANCELLED_BY')}: </b>
            <span>
              {
                helpers.capitalizeFirstWord(requestDetails?.cancelledBy)
              }
            </span>
          </div>)}

          {helpers.andOperator(requestDetails?.transactionDetails?.length > 0, <div className="flex justify-between items-center">
            <b>Payment Method:</b>
            {helpers.capitalizeFirstWord(requestDetails?.transactionDetails?.find(item => item?.transactionType === "wallet")?.paymentMode) || "N/A"}
          </div>)}

          {helpers.andOperator(requestDetails?.transactionDetails?.length > 0, <div className="flex justify-between items-center">
            <b>Transaction Status:</b>
            <span className=" font-medium text-green-500 font-bold">
              {helpers.capitalizeFirstWord(requestDetails?.transactionDetails?.find(item => item?.transactionType === "wallet")?.status) || "N/A"}
            </span>
          </div>)}
          {helpers.andOperator(requestDetails?.spEarning, <div className="flex justify-between items-center">
            <b> {helpers.ternaryCondition(requestDetails?.status=='cancelled','Earnings On Completion','Earnings')}: </b>
            <span className="font-bold">{helpers.formattedAmount(requestDetails?.spEarning)}</span>
          </div>)}

        </ServiceCard>


        {helpers.andOperator(requestDetails?.status !== 'pending', <ServiceCard title="Assigned Driver Details">
          {helpers.andOperator(requestDetails?.driverDetails?.fullName, <div className="flex justify-between items-center">
            <b>Name: </b>
            <span>{requestDetails?.driverDetails?.fullName || "N/A"}</span>
          </div>)}
          {helpers.andOperator(requestDetails?.driverDetails?.mobile, <div className="flex justify-between items-center">
            <b>Phone: </b>
            <span>{requestDetails?.driverDetails?.mobile || "N/A"}</span>
          </div>)}
          {helpers.andOperator(requestDetails?.driverDetails?.email, <div className="flex justify-between items-center">
            <b>Email: </b>
            <span>{requestDetails?.driverDetails?.email || "N/A"}</span>
          </div>)}

          {helpers.andOperator(requestDetails?.tip, <div className="flex justify-between items-center">
            <b>Tip:</b> {helpers.formattedAmount(requestDetails?.tip)}
          </div>)}
          {helpers.andOperator(requestDetails?.rating?.meanRating, <div className="flex justify-between items-center gap-2">
            <b>Rating:</b> <span className="flex items-center gap-1"> <Rating
              name="read-only"
              size="small"
              value={requestDetails?.rating?.meanRating}
              precision={0.5}
              readOnly
            />
              <p className="mt-1">({requestDetails?.rating?.meanRating?.toFixed(2) || 0})</p>
              <span className="cursor-pointer" title="Click to view ratings" onClick={() => { setIsAddFeedback(requestDetails?.rating) }}><FaEye size={20} /></span>
            </span>
          </div>)}


          {helpers.andOperator(requestDetails?.rating?.feedback, <div className="">
            <b>Review:</b> <p className="whitespace-pre-line">{requestDetails?.rating?.feedback}</p>
          </div>)}

        </ServiceCard>)}

        <ServiceCard title="Vehicle Details">
          <div className="flex flex-col md:flex-row gap-4 items-center md:items-center flex-wrap justify-center">
            <div className="flex-1 space-y-1 w-full">
              {helpers.andOperator(requestDetails?.vehicleDetails?.vehicleName, <div className="flex justify-between items-center">
                <b>Vehicle Brand: </b>
                <span>
                  {helpers.capitalizeFirstWord(
                    requestDetails?.vehicleDetails?.vehicleName || "N/A"
                  )}
                </span>
              </div>)}
              {helpers.andOperator(requestDetails?.vehicleDetails?.vinNumber, <div className="flex justify-between items-center">
                <b>VIN Number: </b>
                <span>
                  {
                    requestDetails?.vehicleDetails?.vinNumber || "N/A"
                  }
                </span>
              </div>)}
              {helpers.andOperator(requestDetails?.vehicleDetails?.model, <div className="flex justify-between items-center">
                <b>Model: </b>
                <span>{requestDetails?.vehicleDetails?.model || "N/A"}</span>
              </div>)}
              {helpers.andOperator(requestDetails?.vehicleDetails?.vehicleType, <div className="flex justify-between items-center">
                <b>Vehicle Type: </b>
                <span>
                  {helpers.capitalizeFirstWord(
                    requestDetails?.vehicleDetails?.vehicleType || "N/A"
                  )}
                </span>
              </div>)}
              {helpers.andOperator(requestDetails?.vehicleDetails?.color, <div className="flex justify-between items-center">
                <b>Color: </b>
                <span>
                  {helpers.capitalizeFirstWord(
                    requestDetails?.vehicleDetails?.color || "N/A"
                  )}
                </span>
              </div>)}
              {helpers.andOperator(requestDetails?.vehicleDetails?.year, <div className="flex justify-between items-center">
                <b>Year: </b>
                <span>{requestDetails?.vehicleDetails?.year || "N/A"}</span>
              </div>)}
            </div>

            {helpers.andOperator(requestDetails?.vehicleDetails?.vehicleType, <OImage
              src={requestDetails?.vehicleDetails?.vehicleImage||`/images/${requestDetails?.vehicleDetails?.vehicleType?.toLowerCase()}.png`}
              alt="Vehicle"
              className="w-36 h-24 rounded-lg object-contain"
            />)}
          </div>
        </ServiceCard>

        <ServiceCard title="Customer Details">
          {requestDetails?.status === "pending" ? (
            <div className="flex justify-between items-center">
              <b>Name:</b>
              <span>{requestDetails?.userDetails?.fullName || "N/A"}</span>
            </div>
          ) : (
            <>
              <div className="flex justify-between items-center">
                <b>Name:</b>
                <span>{requestDetails?.userDetails?.fullName || "N/A"}</span>
              </div>
              <div className="flex justify-between items-center">
                <b>Mobile:</b>
                {helpers.ternaryCondition(requestDetails?.userDetails?.mobile,<span>+{requestDetails?.userDetails?.countryCode}-{requestDetails?.userDetails?.mobile}</span>,<span>N/A</span>)}
              </div>

              <div className="flex justify-between items-center">
                <b>Email:</b>
                <span>{requestDetails?.userDetails?.email || "N/A"}</span>
              </div>
            </>
          )}
        </ServiceCard>

        <ServiceCard title="Service Location">
          <p> {requestDetails?.address || "N/A"}</p>
        </ServiceCard>

        {helpers.andOperator(requestDetails?.cancellationReason,<ServiceCard title="Cancellation Reason">
          <p> {requestDetails?.cancellationReason || "N/A"}</p>
        </ServiceCard>)}

       {helpers.andOperator(requestDetails?.dropOffaddress,<ServiceCard title="Drop Location">
          <p>
            {requestDetails?.dropOffaddress || 'N/A'}
          </p>
        </ServiceCard>)}

        <ServiceCard title="Service Notes">
          <p className="whitespace-pre-line">{requestDetails?.notes || "N/A"}</p>
        </ServiceCard>

        {helpers.andOperator(requestDetails?.isPaymentDone, <ServiceCard title="Track Status">
          {requestDetails?.trackStatus?.map((progress, index) => (
            <div key={progress?.id} className="relative !mt-0">
              <div className="flex items-start relative z-10">
                {/* Icon + Line wrapper */}
                <div className="relative flex flex-col items-center">
                  {/* Circle */}
                  <div
                    className={`w-5 h-5 rounded-full flex items-center justify-center
                    ${helpers.ternaryCondition(progress?.status
                      , "bg-green-500"
                      , helpers.ternaryCondition(requestDetails?.status === "cancelled"
                        , "bg-red-500"
                        , "bg-gray-300"
                      )
                    )}`}
                  >
                    {helpers.ternaryCondition(progress?.status,
                      <FaCheck className="text-white text-xs" />
                      , helpers.ternaryCondition(requestDetails?.status === "cancelled"
                        , <AiOutlineClose className="text-white text-xs" />
                        , <FaCheck className="text-white text-xs" />
                      )
                    )}
                  </div>

                  {/* Vertical line */}
                  {index !== requestDetails?.trackStatus?.length - 1 && (
                    <div
                      className={`w-[2px] h-10 ${helpers.ternaryCondition(requestDetails?.status === "cancelled"
                        , "bg-red-500"
                        , helpers.ternaryCondition(progress?.status
                          , "bg-green-500"
                          , "bg-gray-300"
                        )
                      )}`}
                    />
                  )}
                </div>

                {/* Text */}
                <div className="ml-4">
                  <p className="capitalize font-medium">{progress?.name}</p>
                  {progress?.status && progress?.createdAt && (
                    <p className="text-xs text-gray-500">
                      {helpers.getDateAndTime(progress?.createdAt)}
                    </p>
                  )}
                </div>
              </div>
            </div>
          ))}
        </ServiceCard>)}

        <ServiceCard title="Filled Questionnaire">
          {requestDetails?.questionnaireAnswers?.map((item) => (
            <div
              key={item?.questionId}
              className="max-h-60 overflow-auto pr-2 space-y-2"
            >
              <p>
                <b>{item?.question}</b>
              </p>
              <div className="bg-gray-100 p-2 rounded">{item?.answer}</div>

            </div>
          ))}
        </ServiceCard>

        {helpers.andOperator(requestDetails?.receipt, <ServiceCard title="Download Invoice">
          <motion.button
            whileTap={{ scale: 0.96 }}
            whileHover={{ scale: 1.05 }}
            onClick={() => helpers.downloadFile(requestDetails?.receipt)}
            className="mt-3 w-full bg-gradientTo text-white text-sm font-medium px-4 py-2 rounded-lg shadow transition-all"
          >
            📄 Click Here To Download
          </motion.button>
        </ServiceCard>)}
      </div>

      <Dialog
        open={helpers.ternaryCondition(isOpenAddFeedback, true, false)}
        onClose={() => {
          setIsAddFeedback('');
        }}
        className="relative z-[9999] modalBackDrop"
      >
        <div className="fixed z-50 inset-0 flex w-screen justify-center max-h-full overflow-y-auto items-center">
          <div className="relative">
            <div className="px-4 sm:px-0 mx-auto sm:max-w-full w-full sm:w-[593px] themeModal">
              <Dialog.Panel className="scrollModalData relative   bg-white border border-theme-gray700  w-full bg-theme-gray800 rounded-lg md:rounded-xl lg:rounded-2xl overflow-hidden">
                <button type='button'
                  className="absolute border border-theme-color right-4 top-3 w-[20px] h-[20px] flex items-center justify-center rounded-full"
                  onClick={() => {
                    setIsAddFeedback('');

                  }}
                >
                  <IoCloseOutline className=" text-black" />
                </button>

                <div className="p-4 sm:p-6 border-b border-b-[#DADADA]">
                  <h3 className="text-theme-black text-lg md:text-2xl  font-semibold">
                    {t('FEEDBACK_AND_RATINGS')}
                  </h3>
                </div>
                <div className="p-4 sm:p-6 lg:p-[30px] border-b border-b-[#DADADA]">
                  <div className="flex mb-8 flex-col sm:flex-row flex-wrap">
                    <div className="flex flex-col gap-y-4 sm:gap-y-7 flex-1">
                      <div>
                        <span className="text-theme-black font-medium mb-2 inline-block">
                          {t('PROFESSIONALISM')}
                        </span>
                        <span className="flex gap-2.5 " >
                          <Rating name="professionalismRating" value={isOpenAddFeedback?.professionalismRating} readOnly precision={0.5} sx={{ fontSize: 37 }} />
                        </span>
                      </div>
                      <div>
                        <span className="text-theme-black font-medium mb-2 inline-block">
                          {t('COMMUNICATION')}
                        </span>
                        <span className="flex gap-2.5">
                          <Rating name="communicationRating" value={isOpenAddFeedback?.communicationRating} readOnly precision={0.5} sx={{ fontSize: 37 }} />
                        </span>
                      </div>
                     
                    </div>
                    <div className="flex flex-col gap-y-7 mt-5 sm:mt-0">
                      <div>
                        <span className="text-theme-black font-medium mb-2 inline-block">
                          {t('SERVICE')}
                        </span>
                        <span className="flex gap-2.5">
                          <Rating name="serviceRating" value={isOpenAddFeedback?.serviceRating} readOnly precision={0.5} sx={{ fontSize: 37 }} />
                        </span>
                      </div>
                      
                      
                    </div>
                  </div>

                </div>

              </Dialog.Panel>
            </div>
          </div>
        </div>
      </Dialog>
    </motion.div>
  );
}
